import script from "./DictionarySelect.vue?vue&type=script&lang=js"
export * from "./DictionarySelect.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__